import { z } from "zod";

export const vehicleTypeFormSchema = z
  .object({
    name: z.string().min(1, "Field is required and can't be empty.").max(32, "Maximum of 32 characters."),
    capacity: z
      .number({ message: "Field is required and can't be empty." })
      .min(0)
      .max(999)
      .step(1, "Field must be a whole number."),
    bags: z
      .number({ message: "Field is required and can't be empty." })
      .min(0)
      .max(999)
      .step(1, "Field must be a whole number."),
    waitTimeCost: z
      .number({ message: "Field is required and can't be empty." })
      .min(0)
      .max(999.99)
      .step(0.01, "Field must be a maximum of 2 decimal places."),
    costAdjustment: z
      .number({ message: "Field is required and can't be empty." })
      .min(-99)
      .max(99999)
      .step(1, "Field must be a whole number."),
    customCommissionEnabled: z.boolean(),
    customCommissionRate: z.number().optional(),
    vehicleCategoryUuid: z.string().min(1, "Pick a vehicle category to map this type."),
  })
  .refine(
    (data) => {
      if (data.customCommissionEnabled) {
        return data.customCommissionRate !== undefined && data.customCommissionRate >= 0 && data.customCommissionRate <= 100;
      }
      return true;
    },
    { message: "Commission must be a whole number between 0 and 100.", path: ["customCommissionRate"] }
  );

export type VehicleTypeFormData = z.infer<typeof vehicleTypeFormSchema>;
